import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SectionTitle from '@/components/base/SectionTitle';

export default function FeaturedCollections() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="px-6 md:px-10 max-w-[1280px] mx-auto">
        <SectionTitle
          label={t('home.featured.label')}
          title={t('home.featured.title')}
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <Link
            to="/category/all?sort=popular"
            className="group bg-foreground-950 rounded-xl p-6 md:p-8 flex flex-col justify-between min-h-[280px] relative overflow-hidden cursor-pointer"
          >
            <div>
              <span className="inline-flex items-center justify-center w-10 h-10 rounded-lg bg-background-50/15 text-background-50 mb-5">
                <i className="ri-fire-line text-lg"></i>
              </span>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-background-50 mb-2">
                {t('home.featured.hotSeries.title')}
              </h3>
              <p className="text-sm text-background-50/60 mb-4">
                {t('home.featured.hotSeries.desc')}
              </p>
              <div className="flex flex-wrap gap-2">
                {(['恋爱', '奇幻', '动作', '悬疑'] as const).map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1 rounded-full text-xs font-medium bg-background-50/10 text-background-50/80 border border-background-50/15"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
            <span className="text-sm text-background-50/50 mt-4">128部 连载中</span>
          </Link>

          <Link
            to="/category/all?sort=newest"
            className="group rounded-xl overflow-hidden relative min-h-[280px] cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Beautiful%20Korean%20manhwa%20cover%20collage%20with%20warm%20coral%20and%20soft%20pink%20tones%2C%20romantic%20and%20fantasy%20themed%20illustration%2C%20artistic%20composition%2C%20delicate%20linework%2C%20dreamy%20atmosphere%2C%20professional%20webtoon%20art%20style&width=600&height=500&seq=featured-new-arrival&orientation=landscape"
              alt="新作上架"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-foreground-950/40"></div>
            <div className="relative z-10 p-6 md:p-8 flex flex-col justify-end h-full">
              <span className="inline-block px-2.5 py-1 rounded-full text-[10px] font-bold bg-accent-500 text-background-50 mb-3 w-fit">
                NEW
              </span>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-background-50 mb-1">
                {t('home.featured.newArrival.title')}
              </h3>
              <p className="text-sm text-background-50/70">
                {t('home.featured.newArrival.desc')}
              </p>
            </div>
          </Link>

          <Link
            to="/category/all?sort=completed"
            className="group bg-white rounded-xl p-6 md:p-8 flex flex-col justify-between min-h-[280px] border border-background-200/70 cursor-pointer"
          >
            <div>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-2">
                {t('home.featured.completed.title')}
              </h3>
              <p className="text-sm text-foreground-500 mb-5">
                {t('home.featured.completed.desc')}
              </p>
            </div>
            <div>
              <span className="text-sm text-secondary-600 font-medium">
                {t('home.featured.completed.count')}
              </span>
              <div className="mt-4 flex gap-2">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20completed%20manhwa%20cover%20thumbnail%2C%20romance%20drama%20theme%2C%20warm%20golden%20tone%2C%20small%20format%20book%20cover%20style%2C%20clean%20design&width=80&height=110&seq=completed-thumb-01&orientation=portrait"
                  alt="完结作品"
                  className="w-14 h-20 rounded-md object-cover object-top"
                  loading="lazy"
                />
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20completed%20series%20cover%20thumbnail%2C%20fantasy%20action%20theme%2C%20deep%20coral%20tone%2C%20small%20format%2C%20professional%20cover%20art&width=80&height=110&seq=completed-thumb-02&orientation=portrait"
                  alt="完结作品"
                  className="w-14 h-20 rounded-md object-cover object-top"
                  loading="lazy"
                />
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20completed%20series%20cover%20thumbnail%2C%20slice%20of%20life%20theme%2C%20soft%20warm%20tone%2C%20small%20format%2C%20clean%20cover%20design&width=80&height=110&seq=completed-thumb-03&orientation=portrait"
                  alt="完结作品"
                  className="w-14 h-20 rounded-md object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}